import { ParsedUrlQuery } from 'querystring';
import { FeatureFlags } from '../types/feature-flags';

export const getActiveFeatureFlagsFromUrl = (
  featureFlags: Record<string, unknown>,
  query: ParsedUrlQuery,
) => {
  return Object.entries(featureFlags)
    .filter(([flagKey, flagVal]) => {
      if (query?.[flagKey] === flagVal) return true;
      return false;
    })
    .map((feature) => feature[0]) as FeatureFlags[];
};
